import { makeStyles } from "@mui/styles";
import { createTheme } from "@mui/material/styles";

const theme = createTheme();

const useQuestionSectionStyle = makeStyles(() => ({
  root: {
    display: "flex",
    flexDirection: "column",
    marginTop: "20px",
    "@media (max-width:599px)": {
      marginTop: "6px",
    },
    "@media (min-width: 766px) and (max-width: 898px)": {
      marginTop: "10px",
    },
  },
  paper: {
    paddingTop: "40px",
    paddingBottom: "40px",
    height: "calc(100vh - 320px)",
    overflow: "auto",
    boxShadow: "none !important",
    [theme.breakpoints.down("sm")]: {
      padding: "8px",
      // On mobile, height is managed by content flow
      height: "auto",
      minHeight: "40vh",
      maxHeight: "55vh",
    },
    "&::-webkit-scrollbar": {
      width: "0px",
    },
    // Ensure images inside paper are responsive
    "& img": {
      maxWidth: "100%",
      height: "auto",
    },
    "& table": {
      display: "block",
      overflowX: "auto",
      maxWidth: "100%",
    },
    "@media (min-width: 766px) and (max-width: 898px)": {
      fontSize: "0.7rem",
      height: "calc(100vh - 280px)",
      paddingTop: "20px",
      paddingBottom: "20px",
    },
  },
  questionContainer: {
    "& img": {
      maxWidth: "100%",
      height: "auto",
    },
    "@media (min-width: 766px) and (max-width: 898px)": {
      fontSize: "0.7rem",
    },
  },
  questionTitle: {
    fontWeight: "bold",
    padding: "0px 0px 4px 0px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    borderBottom: "1px solid black",
    "@media (max-width:599px)": {
      fontSize: "0.85rem",
      padding: "0px 0px 2px 0px",
    },
    "@media (min-width: 766px) and (max-width: 898px)": {
      fontSize: "0.5rem",
    },
  },
  upWrapper: {
    padding: "4px 0px 30px 0px",
    display: "flex",
    justifyContent: "end",
    marginTop: "16px",
    borderTop: "1px solid black",
    alignSelf: "baseline",
    "@media (max-width:599px)": {
      padding: "4px 0px 8px 0px",
      marginTop: "8px",
    },
    "@media (min-width: 766px) and (max-width: 898px)": {
      fontSize: "0.7rem",
    },
  },
  givenSection: {
    marginBottom: "16px",
    "@media (min-width: 766px) and (max-width: 898px)": {
      fontSize: "0.7rem",
    },
  },
  finalReaction: {
    margin: "16px 0",
    fontWeight: "500",
    "@media (min-width: 766px) and (max-width: 898px)": {
      fontSize: "0.7rem",
    },
  },
  scrollableContent: {
    maxHeight: "400px",
    overflowY: "auto",
    marginBottom: "10px",
    "@media (min-width: 766px) and (max-width: 898px)": {
      fontSize: "0.7rem",
    },
  },
  buttonGroup: {
    display: "flex",
    flexWrap: "wrap",          // always wrap so buttons stack when needed
    gap: "8px",
    justifyContent: "flex-start",
    paddingBottom: "6px",
    "& button": {
      fontSize: "0.75rem !important",
      padding: "6px 10px !important",
      borderRadius: "2px !important",
    },
    "@media (max-width:599px)": {
      gap: "5px",
      "& button": {
        flex: "1 1 calc(50% - 5px)",
        fontSize: "0.65rem !important",
        padding: "5px 6px !important",
        minWidth: "0 !important",
        whiteSpace: "normal !important",
        lineHeight: "1.2 !important",
      },
    },
    "@media (min-width:600px) and (max-width:899px)": {
      "& button": {
        fontSize: "0.7rem !important",
        padding: "5px 8px !important",
      },
    },
    "@media (min-width: 766px) and (max-width: 898px)": {
      gap: "5.6px",
      paddingBottom: "7px",
      "& button": {
        fontSize: "0.7rem !important",
        padding: "4.2px 8.4px !important",
        minWidth: "auto !important",
      },
    },
  },
  navButtons: {
    position: "sticky",
    bottom: 0,
    left: 0,
    right: 0,
    backgroundColor: "white",
    zIndex: 10,
    padding: "8px 16px",
    boxShadow: "0px -2px 10px rgba(0,0,0,0.1)",
    "@media (max-width:599px)": {
      padding: "6px 8px",
      position: "fixed",
      width: "100%",
    },
    "@media (min-width:600px) and (max-width:899px)": {
      padding: "8px 12px",
    },
    "@media (min-width: 766px) and (max-width: 898px)": {
      marginTop: "14px",
      padding: "7px 16.8px",
    },
    "@media (min-width: 992px)": {
      padding: "7px 16.8px",
    },
  },
  finalpopup: {
    padding: "1rem 1rem 0 1rem",
    "& .MuiTypography-h6": {
      color: "#263238",
      fontFamily: "Satoshi",
      fontSize: "2rem",
      fontStyle: "normal",
      fontWeight: "700",
      textTransform: "capitalize",
    },
    "@media (max-width:599px)": {
      padding: "0.5rem",
      "& .MuiTypography-h6": {
        fontSize: "1.2rem",
      },
    },
    "@media (min-width: 766px) and (max-width: 898px)": {
      fontSize: "0.7rem",
      "& .MuiTypography-h6": {
        fontSize: "1.4rem",
      },
    },
  },
  p1: {
    padding: "1rem",
    "@media (max-width:599px)": {
      padding: "0.5rem",
      fontSize: "0.8rem",
    },
    "@media (min-width: 766px) and (max-width: 898px)": {
      fontSize: "0.7rem",
    },
  },
  contentContainer: {
    width: "100%",
    padding: "10px",
    "@media (max-width:599px)": {
      padding: "6px",
      fontSize: "0.82rem",
    },
    "@media (min-width: 766px) and (max-width: 898px)": {
      fontSize: "0.7rem",
    },
  },
}));

export default useQuestionSectionStyle;